"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	colors: {
		accounts: "#ff5559",
		write: "#f60",

		//default value, must be overwritten
		primary: "#aaa",
		secondary: "#aaa",

		white: "#fff",
		lightgray: "#eee",
		midgray: "#ddd",
		gray: "#aaa",
		darkgray: "#666",
		black: "#333",

		red: "#f92672",
		orange: "#fd971f",
		yellow: "#e6db74",
		green: "#a6e22e",
		blue: "#66d9ef",
		purple: "#ae81ff"
	},

	sizes: {
		padding: {
			horizontal: 1,
			vertical: 0.67
		},

		margin: {
			horizontal: 0,
			left: 0,
			right: 0,
			vertical: 0.67
		},

		borderRadius: "3px",
		arrowWidth: 0.6
	},

	functions: {
		shadow: function shadow(height) {
			var over = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

			var h = height - over;
			return "\n\t\t\t\tbox-shadow:\n\t\t\t\t\t0px " + 3 * h + "px " + h + "px " + -h + "px rgba(0, 0, 0, " + h / 10 + "),\n\t\t\t\t\t0px " + h + "px " + 2 * h + "px " + h + "px rgba(0, 0, 0, " + h / 20 + ");\n\t\t\t\tz-index: " + height + ";\n\t\t\t";
		}
	}
};

//# sourceMappingURL=theme.js.map


//////////////////
// WEBPACK FOOTER
// ./~/codogo-react-widgets/dist/theme.js
// module id = 211
// module chunks = 0